import type {
  AuthUser,
  BlockUserRequest,
  ChatLogEntry,
  PlayerReport,
  ServerStatus,
  LoginRequest,
  RegisterRequest,
} from '@pixelworld/shared';
import { api } from '../../lib/api';

export const fetchCurrentUser = () => api<{ user: AuthUser | null }>('GET', '/auth/me');

export const login = (request: LoginRequest) =>
  api<{ user: AuthUser }>('POST', '/auth/login', request);

export const register = (request: RegisterRequest) =>
  api<{ user: AuthUser }>('POST', '/auth/register', request);

export const logout = () => api<null>('POST', '/auth/logout');

export const setUserBlocked = (request: BlockUserRequest) =>
  api<{ user: AuthUser; blocked: boolean }>('POST', '/admin/users/block', request);

export const fetchChatLog = () => api<{ entries: ChatLogEntry[] }>('GET', '/admin/chat');
export const fetchServerStatus = () => api<ServerStatus>('GET', '/admin/status');
export const fetchReports = () => api<{ reports: PlayerReport[] }>('GET', '/admin/reports');
export const markReportSeen = (id: string) =>
  api<{ ok: true }>('POST', `/admin/reports/${encodeURIComponent(id)}/seen`);
